export const Domaincron = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 25 25" fill="none">
    <path
      d="M12.0605 6.96973L16.0605 12.9697L21.0605 8.96973L19.0605 18.9697H5.06055L3.06055 8.96973L8.06055 12.9697L12.0605 6.96973Z"
      fill="#E69217"
    />
  </svg>
);
